import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export function formatTime(time) {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  const h = parseInt(hours);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export const SERVICE_TYPES = [
  'Hardwood Refinishing',
  'Buff & Recoat',
  'LVP Installation',
  'Stair Flooring',
  'Floor Repair',
  'Flooring Installation',
  'Other'
];

export const FLOORING_TYPES = [
  'Hardwood',
  'Vinyl/LVP',
  'Tile',
  'Stairs',
  'Baseboards',
  'Repair',
  'Other'
];

export const ROOM_TYPES = [
  'Kitchen',
  'Living Room',
  'Hallway',
  'Bathroom',
  'Bedroom',
  'Basement',
  'Stairs',
  'Dining Room',
  'Office',
  'Other'
];

export const STYLE_TYPES = [
  'Modern',
  'Classic',
  'Luxury',
  'Minimal',
  'Rustic',
  'Contemporary',
  'Traditional'
];

export const LEAD_STATUSES = [
  { value: 'new', label: 'New', color: 'bg-blue-100 text-blue-800' },
  { value: 'contacted', label: 'Contacted', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'scheduled', label: 'Scheduled', color: 'bg-green-100 text-green-800' },
  { value: 'won', label: 'Won', color: 'bg-emerald-500 text-white' },
  { value: 'lost', label: 'Lost', color: 'bg-red-100 text-red-800' }
];
